<template lang="pug">
  .form-agv-details(:data-telegram-account-binding-enabled="isTelegramAccountBindingEnabled")
    .section(v-if="!isInPasswordChangeMode")
      .label
        | Город
      .edit-box
        el-select.cc-town-select(v-if="towns.length > 1" v-model='customer.town_id')
          el-option(v-for="item in towns"
          :value-key="item.id"
          :key="item.id"
          :label="item.name"
          :value="item.id")
        span(v-else)
          | {{ towns[0].name }}
    .section(v-if="isInAggregatorMode")
      .label
        | Логин
      .edit-box
        .wrap-input
          | {{customer.login}}
    .section(v-else)
      .label
        | Логин и пароль
      .edit-box
        .wrap-input
          input.cc-login-input(:class='{error: errors.login}' placeholder="example@mail.ru" style="width: 130px;" type="text" v-model='customer.login')
        .wrap-input(v-if="isLoginTaken")
          span
            | Вы уже зарегистрированы.
            router-link(to='/login') Нажмите, чтобы войти
        .wrap-input
          input.cc-password-input(:class='{error: errors.password}' placeholder="пароль" type="text" v-model='customer.password')
    .section(v-if="!isInPasswordChangeMode")
      .label
        | Контакты
      .edit-box
        .wrap-input
          input.cc-first-name-input(:class='{error: errors.first_name}' placeholder="имя" type="text" v-model='customer.first_name')
        .wrap-input
          input.cc-last-name-input(:class='{error: errors.last_name}' placeholder="фамилия" type="text" v-model='customer.last_name')
        .wrap-input
          span.phone-eight(style='line-height: 17px;')
            | {{countryCode | phonePrefix}}
          input.cc-phone-input(:class='{error: errors.phone}' placeholder="XXXXXXXXXX" maxlength="10" type="text" v-model='customer.phone')
    .section(v-if="!isInPasswordChangeMode")
      .label
      .edit-box
        .block
          .wrap-input(v-if="!customer.id")
            el-checkbox(v-model="customer.is_professional")
              | Я – специалист праздничной сферы
          .wrap-input(v-if="customer.is_professional")
            input(:class='{error: errors.company_name}' placeholder="название компании" type="text" v-model='customer.company_name')
        .block(v-if="isInAggregatorMode")
          .wrap-input
            el-checkbox(v-model="customer.is_subscribed_to_newsletter")
              | Я хочу получать новости Пифакита
        .block(v-else)
          .wrap-input
            el-checkbox(v-model="customer.wants_to_receive_news")
              | Я хочу получать новости {{renterGenitiveName}}
        .block(v-if="customer.id")
          .wrap-input
            el-checkbox(v-model="customer.wants_to_receive_originals")
              | Я хочу получать оригиналы документов
          .wrap-input(v-if="customer.wants_to_receive_originals")
            input(:class='{error: errors.location}' placeholder="город" type="text" v-model='customer.location')
          .wrap-input(v-if="customer.wants_to_receive_originals")
            input(:class='{error: errors.address}' placeholder="индекс, улица, дом, офис" type="text" v-model='customer.address')
    .section(v-if="!isInPasswordChangeMode && isInAggregatorMode && isTelegramAccountBindingEnabled")
      .label
        | Телеграм
      .edit-box
        div(v-if="customer && customer.telegram_account")
          span
            span.telegram-username(v-if="customer.telegram_account.username") @{{ customer.telegram_account.username }}
            el-button(type="danger" size="small" @click="onDisconnectTelegram") Отключить уведомления
        div(v-else)
          .custom-telegram-button-wrapper
            el-button(type="primary" size="small") Включить уведомления
            div(ref="telegramButton")
</template>

<script>
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'form-agv-details',
  props: {
    countryCode: String,
    renterGenitiveName: String,
    customer: Object,
    errors: Object,
    isInPasswordChangeMode: Boolean,
    isInAggregatorMode: Boolean
  },
  data() {
    return {
      tgCallbackName: `onTelegramAuth_${Math.random().toString(36).slice(2)}`
    }
  },
  computed: {
    towns() {
      return this.$store.state.town.towns
    },
    isLoginTaken() {
      if (!this.errors) return false
      if (Array.isArray(this.errors.login)) {
        return this.errors.login.some(m => /существует/i.test(String(m)))
      }
      return false
    },
    isTelegramAccountBindingEnabled() {
      const customer = this.customer || {}
      const flags = customer.feature_flags

      if (!flags) {
        return false
      }

      return Boolean(
        flags.telegram_account_binding_enabled
      )
    }
  },
  watch: {
    'customer.login': 'clearError',
    'customer.password': 'clearError',
    'customer.first_name': 'clearError',
    'customer.last_name': 'clearError',
    'customer.is_professional': 'clearError',
    'customer.company_name': 'clearError',
    'customer.town': 'clearError',
    isTelegramAccountBindingEnabled(value) {
      if (!value) {
        this.destroyTelegramWidget()
        return
      }

      if (this.customer && !this.customer.telegram_account) {
        this.renderTelegramWidget()
      }
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window[this.tgCallbackName] = (user) => this.onTelegramAuth(user)
    }
    if (this.isTelegramAccountBindingEnabled && !this.customer.telegram_account) {
      this.renderTelegramWidget();
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined' && this.tgCallbackName) {
      try { delete window[this.tgCallbackName] } catch (e) { window[this.tgCallbackName] = undefined }
    }
    this.destroyTelegramWidget()
  },
  methods: {
    renderTelegramWidget() {
      if (!this.isTelegramAccountBindingEnabled) {
        return
      }

      this.$nextTick(() => {
        if (this.$refs.telegramButton) {
          this.$refs.telegramButton.innerHTML = '';

          const script = document.createElement('script');
          script.src = 'https://telegram.org/js/telegram-widget.js?22';
          script.setAttribute('data-telegram-login', window.TELEGRAM_BOT_NAME);
          script.setAttribute('data-size', 'large');
          script.setAttribute('data-radius', '5');
          script.setAttribute('data-onauth', `${this.tgCallbackName}(user)`);
          script.setAttribute('data-request-access', 'write');
          this.$refs.telegramButton.appendChild(script);
        }
      });
    },

    destroyTelegramWidget() {
      if (this.$refs && this.$refs.telegramButton) {
        this.$refs.telegramButton.innerHTML = '';
      }
    },

    onTelegramAuth(user) {
      axios.post('/api/aggregator_customer/telegram/connect', { telegram_account: user })
        .then(response => {
          Message({
            message: 'Ваш Telegram аккаунт успешно привязан',
            type: 'success'
          });
          this.$set(this.customer, 'telegram_account', response.data);
        })
        .catch(error => {
          if (error.response.status === 409) {
            Message.error('Telegram аккаунт привязан к другому пользователю');
          } else {
            Message.error('Произошла ошибка при привязке Telegram аккаунта');
          }
        });
    },

    onDisconnectTelegram() {
      MessageBox.confirm('Вы уверены, что хотите отвязать ваш Telegram аккаунт? Вы перестанете получать уведомления.', 'Подтверждение', {
        confirmButtonText: 'Да, отвязать',
        cancelButtonText: 'Отмена',
        type: 'warning'
      }).then(() => {
        axios.delete('/api/aggregator_customer/telegram/disconnect')
          .then(() => {
            Message({
              type: 'success',
              message: 'Аккаунт успешно отвязан'
            });
            this.$set(this.customer, 'telegram_account', null);
            this.renderTelegramWidget();
          })
          .catch(() => {
            Message.error('Произошла ошибка при отвязке аккаунта');
          });
      }).catch(() => { });
    },

    clearError() {
      this.$emit('clearError')
    }
  }
}
</script>

<style scoped>
.popup {
  font-size: 14px;
}

.label {
  width: 216px;
  color: #4A4A4A;
  line-height: 15px;
}

.wrap-input {
  color: grey;
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
}

.section {
  display: flex;
  align-items: baseline;
  padding-bottom: 17px;
}

.edit-box {
  width: 100%;
}

.block {
  display: block;
  margin-bottom: 15px;
}

input {
  flex-grow: 1;
  outline: none;
  min-width: 120px;
  border: none;
  background: #ffffff;
  color: #4A90E2;
  font-size: inherit;
  line-height: 18px;
  height: 18px;
  padding: 0;
}

.big-btn {
  color: #4A4A4A;
  font-size: inherit;
  line-height: 51px;
  display: block;
  border: 1px solid #BCBCBC;
  width: 288px;
  height: 53px;
  text-align: center;
  transition: ease 0.4s 0s;
  border-radius: 3px;
}

.big-btn.active {
  border-color: #7799E4;
  box-shadow: 0 0 0 1px #7799E4;
}

.phone-eight {
  color: #4A90E2;
  font-size: inherit;
  line-height: 15px;
  margin-right: 3px;
  display: inline-block;
}

.btn-reg {
  font-size: inherit;
  line-height: 15px;
  background: #4990E2;
  padding: 11px 16px 10px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  display: block;
  color: #ffffff;
  float: right;
}

.error {
  color: #D0021B;
}

.error::-webkit-input-placeholder {
  color: #E88290;
}

.error:-moz-placeholder {
  color: #E88290;
}

.branch-select {
  margin-top: -17px;
}

.popup >>> .el-checkbox {
  display: block;
}

.popup >>> .el-checkbox__label {
  color: #4A90E2;
}

.popup >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #4A90E2;
}

.custom-telegram-button-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.custom-telegram-button-wrapper>div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
  cursor: pointer;
}

.telegram-username {
  color: #4990E2;
  margin-right: 12px;
  font-weight: normal;
}
</style>
